<div class="costs">
  <h2 class="cell" [innerHTML]="textkeyPrefix + '.headline' | translate"></h2>
  @if(teaser) {
    <p [innerHTML]="teaser | translate"></p>
  }

  <div class="grid-x costs-content">
    <div class="cell medium-12 large-4">
      <app-advisor-image [path]=imagePath></app-advisor-image>
    </div>

    <div class="grid-x cell medium-12 large-8 costs-compare">
      <div class="cell small-12 medium-6 large-6">
        <strong [innerHTML]="textkeyPrefix + '.gesamt' | translate"></strong>

          <div class="euro">
            @if (textPlaceholder?.costs_euro_year) {
              <p [innerHTML]="textkeyPrefix + '.gesamt.euro' | translate" ></p>
              <strong class="sum">{{textPlaceholder.costs_euro_year}} €</strong>
            }
            @else {
              <p [innerHTML]="(textkeyPrefix + '.bewertung.' + (savingsEuroYear > 0 ? stage : 'kein')) | translate: textPlaceholder"></p>
              <strong class="sum">{{textPlaceholder?.countOfOverAverage}}/{{textPlaceholder?.countOfItems}} <span>{{(textkeyPrefix + '.punkt.' + stage) | translate}}</span></strong>
            }
          </div>
      </div>

      <div class="cell small-12 medium-6 large-6">
        <strong [innerHTML]="textkeyPrefix + '.einsparpotenzial' | translate"></strong>
        <div class="euro" [class.no-savings]="savingsEuroYear <= 0 || textPlaceholder?.savings_euro_year?.includes('-')">
          @if (savingsEuroYear > 0 || textPlaceholder?.savings_euro_year?.includes('-')) {
            <p [innerHTML]="(textkeyPrefix + '.einsparpotenzial.euro.' + stage) | translate"></p>
            <strong class="sum">
              {{ savingsEuroYear }} €
              @if (showTimespan) {
                <span>{{(textkeyPrefix + '.jaehrlich') | translate}}</span>
              }
            </strong>
          }
          @else {
            <p [innerHTML]="textkeyPrefix + '.einsparpotenzial.euro.null' | translate"></p>
            <app-advisor-image [path]="'/all/party.svg'"></app-advisor-image>
          }
        </div>
      </div>
    </div>
  </div>

</div>
